import { AutogenModelEdiorderProfileDisplay, AutogenRowEdiorderProfileDisplay } from "./autogen/AutogenModelEdiorderProfileDisplay";

export class ModelEdiorderProfileDisplay extends AutogenModelEdiorderProfileDisplay<RowEdiorderProfileDisplay> {
	constructor() {
		super(RowEdiorderProfileDisplay);
	}
}

export class RowEdiorderProfileDisplay extends AutogenRowEdiorderProfileDisplay {
}